import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/shared/models/security/user';
import { FacadeService } from '../services/facade.service';
import { Authority } from '../../shared/models/security/authority';

@Injectable({
	providedIn: 'root'
})
export class AuthorityGuard implements CanActivate {
	user: User;
	constructor(private facade: FacadeService, private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		let profiles = route.data.profiles as Array<Authority>; //Récupération des paramètres transmis par la route
		this.user = this.facade.dataStorageService.getUser();

		//si le profile de l'utilisateur est dans la liste transmise, autorise l'accès sinon le redirige vers le dashboard
		//if (profiles.some((authority) => authority === this.user.profile.id)) {
			return true;
		// } else {
		// 	this.router.navigate(['dashboard']);
		// 	return false;
		// }
	}
}
